import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import LinearProgress from '@mui/material/LinearProgress';

class LoadProgress extends React.Component {

  render() {
    return (
      <div>
        <Dialog
          open={this.props.open}
          fullWidth={true}
        // disableEscapeKeyDown
        >
          <DialogContent style={{ textAlign: 'center', }}>
            <LinearProgress mode="indeterminate" style={{ textAlign: 'center', }} />
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default LoadProgress;